import { useStateContainer } from '@state-containers/react';
import { TimeBlockState } from '../state/TimeBlockState';

export const useTimeBlockState = () => {
  return useStateContainer(TimeBlockState);
};
